import React from "react";
import "../DesignerPropertiesPanel.css";

const ImageProperties = ({
  selectedObject,
  updateObjectDataField,
  onOpenLibrary,
}) => {
  const dataJson = selectedObject.data_json || {};

  return (
    <div className="dp-section">
      <h4 className="dp-section-title">Content</h4>

      <div className="dp-field">
        <label className="dp-label">Image Source</label>
        <input
          type="text"
          value={dataJson.src || ""}
          onChange={(e) =>
            updateObjectDataField(selectedObject.id, "src", e.target.value)
          }
          className="dp-input"
        />
      </div>

      <div className="dp-field">
        <label className="dp-checkbox-label">
          <input
            type="checkbox"
            checked={dataJson.transparentBackground ?? true}
            onChange={(e) =>
              updateObjectDataField(
                selectedObject.id,
                "transparentBackground",
                e.target.checked
              )
            }
          />
          Transparent Background
        </label>
      </div>

      <div className="dp-field">
        <button
          type="button"
          onClick={onOpenLibrary}
          className="dp-button-primary"
        >
          Open Image Library
        </button>
      </div>

      {dataJson.src && (
        <div className="dp-field">
          <label className="dp-label">Preview</label>
          <div className="dp-preview-box">
            <img
              src={dataJson.src}
              alt="Selected asset"
              className="dp-preview-image"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageProperties;